var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorFilledCheck = function SvgIconArtGeneratorFilledCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_art_generator_filled_check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.267c6.292 0 11.4 5.108 11.4 11.4s-5.108 11.4-11.4 11.4S.6 18.959.6 12.667s5.108-11.4 11.4-11.4M6.12 13.31l3.508 3.485a.876.876 0 0 0 1.238-.002l7.016-7.015a.878.878 0 0 0-1.24-1.24l-6.397 6.397-2.888-2.87a.878.878 0 0 0-1.237 1.245",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_art_generator_filled_check_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .667h24v24H0z"
  })))));
};
export default SvgIconArtGeneratorFilledCheck;